<template>
  <pt-award-audit class="pt-award-audit__page" :business-type="businessType"></pt-award-audit>
</template>

<script>
import PtAwardAudit from 'cps/new-to-old-audit/pt-award-audit/withData'
export default {
  name: 'pt-award-audit__view',
  props: {
    businessType: {
      type: String
    }
  },
  components: {
    'pt-award-audit': PtAwardAudit
  }
}
</script>
